import {Calendar} from 'vanilla-calendar-pro';

const MIN_NIGHTS = shortTermSettings.min_nights;
const MAX_NIGHTS = shortTermSettings.max_nights;


const inquireShortTermPopup = document.getElementById('inquireShortTermPopup');
const inquireShortTermPopupClose = document.getElementById('inquireShortTermPopupClose');


const inquireShorTermTriggers = document.querySelectorAll('._js-short-term-inquire');

inquireShorTermTriggers.forEach(trigger=>{
    trigger.addEventListener('click', ()=>{
        inquireShortTermPopup.classList.remove('hidden')
        document.documentElement.classList.add('no-scroll');
    })
})


inquireShortTermPopupClose.addEventListener('click', ()=>{
    inquireShortTermPopup.classList.add('hidden')
    document.documentElement.classList.remove('no-scroll');
});


function getMinDate(){
    // min date should be always next day.
    // but if friday, saturday or sunday min date should be monday;

    const date = new Date();

    const dayName = date.toLocaleString('en-us', {
        weekday:'long',
        timeZone: 'Europe/Vilnius',
    });
    const nextDay = new Date(date);

    switch (dayName) {
        case 'Friday':
            nextDay.setDate(date.getDate() + 3); // Friday +3 = monday
            break;
        case 'Saturday':
            nextDay.setDate(date.getDate() + 2); // Saturday +2 = monday
            break;
        case 'Sunday':
            nextDay.setDate(date.getDate() + 1); // Sunday +1 = monday
            break;
        default:
            nextDay.setDate(date.getDate() + 1);
            break;
    }

    return nextDay;
}

function rangeCalendar(config){

    const minDate = getMinDate();

    const defaultSettings = {
        selectedTheme: 'light',
        type: 'multiple',
        displayMonthsCount: 2,
        monthsToSwitch: 1,
        selectionDatesMode: 'multiple-ranged',
        displayDatesOutside: false,
        positionToInput: 'left',
        inputMode: true,
        // dateMin: 'today',
        dateMin: minDate,
        ...config.calendarOptions,
        styles: {
            arrowPrev: 'arrow-prev',
            arrowNext: 'arrow-next'
        },
    };

    function handleDateClick(self, event) {
        // console.log(self);
        updateButtonDates(self.context.selectedDates, config.dateFromButton, config.dateToButton)
        resetDisabledDays()


        if (self.context.selectedDates[0] && !self.context.selectedDates[1]) {
            const currentDay = new Date(self.context.selectedDates[0])
            createDisabledDates(currentDay)
        }


        // if (self.context.selectedDates[0] && self.context.selectedDates[1]){

            if (self.context.selectedDates[0] && self.context.selectedDates[1]) {

                const days_diff= getDatesDiff(self.context.selectedDates[0], self.context.selectedDates[1])

                // console.log(days_diff)
                if (days_diff > MAX_NIGHTS) {

                    inquireShortTermPopup.classList.remove('hidden')
                    document.documentElement.classList.add('no-scroll');
                }else{
                    config.onBothDatesSelected(self.context.selectedDates);
                }




            } else{
                console.log('NOT both dates selected')
            }

        // }else{
        //     console.log('NOT both dates selected')
        // }
    }

    function updateButtonDates(datesArray, buttonFrom, buttonTo) {

        const checkInButtonText = buttonFrom.querySelector('span');
        const checkOutButtonText = buttonTo.querySelector('span');

        if (datesArray[0]) {
            checkInButtonText.innerText = datesArray[0];
        } else {
            checkInButtonText.innerText = 'Check in';
        }

        if (datesArray[1]) {
            checkOutButtonText.innerText = datesArray[1];
        } else {
            checkOutButtonText.innerText = 'Check out'
        }
    }

    function createDisabledDates(currentDay) {

        const nextDay = new Date(currentDay);
        nextDay.setDate(currentDay.getDate() + 1);

        const minEndDate = new Date(currentDay);
        minEndDate.setDate(currentDay.getDate() + MIN_NIGHTS - 1); // -1 since min Date should be selectable.

        // console.log(minEndDate)
        // console.log(nextDay)


        for (let i = 1; i < MIN_NIGHTS; i++) {
            const targetDateForward = new Date(currentDay);
            targetDateForward.setDate(currentDay.getDate() + i);

            const targetDateBackward = new Date(currentDay);
            targetDateBackward.setDate(currentDay.getDate() - i);

            const dateStringForward = targetDateForward.toISOString().split('T')[0];
            const forwardDatesDivs = document.querySelectorAll(`div[data-vc-date="${dateStringForward}"]`);

            const dateStringBackward = targetDateBackward.toISOString().split('T')[0];
            const backwardDatesDivs = document.querySelectorAll(`div[data-vc-date="${dateStringBackward}"]`);


            // console.log(dateStringForward)
            // console.log(forwardDatesDivs)

            forwardDatesDivs.forEach(dateElement=>{
                setDateAsDisabled(dateElement)
            })

            backwardDatesDivs.forEach(dateElement=>{
                setDateAsDisabled(dateElement)
            })
        }
    }

    function setDateAsDisabled(dateElement){
        dateElement.classList.add('disabled');
        dateElement.style.pointerEvents = 'none';
        dateElement.tabIndex = -1;

        const button = dateElement.querySelector('.vc-date__btn');
        if (button) {
            button.classList.add('disabled');
            button.style.pointerEvents = 'none';
            button.setAttribute('tabindex', '-1');
            console.log(button.tabIndex)
            button.disabled = true;
        }
    }

    function resetDisabledDays(){
        const disabledDates = document.querySelectorAll('div[data-vc-date].disabled');
        // console.log(disabledDates)

        disabledDates.forEach(disabledDate=>{
            disabledDate.classList.remove('disabled');
            disabledDate.style.pointerEvents = 'auto';

            const button = disabledDate.querySelector('.vc-date__btn');
            if (button) {
                button.classList.remove('disabled');
                button.style.pointerEvents = 'auto';
                button.removeAttribute('tabindex');
                button.disabled = false;
            }

        })
    }


    function getDatesDiff(date_from, date_to){
        const date1 = new Date(date_from);
        const date2 = new Date(date_to);

        const diffInDays = Math.ceil((date2 - date1) / (1000 * 60 * 60 * 24));

        return diffInDays
    }


    const calendar = new Calendar(config.selector, {
        ...defaultSettings,
        onClickDate: (self, event) => {
            handleDateClick(self, event, config.someParam, config.anotherParam);
        }
    });

    return calendar;
}

export default rangeCalendar;